import { FunctionComponent } from 'react';

import { Form, FormTheme } from '@kanda-libs/ks-component-ts';
import { Button, Loader, Text } from '@kanda-libs/ks-design-library';

import ActionRequired from 'components/ActionRequired';

import SatNoteFormInitialNotice from './InitialNotice';
import SatNoteFormLoader from './Loader';
import SatNoteFormQuestions from './Questions';
import SatNoteFormTerms from './Terms';
import { HOWDENS_FOOTER } from './constants';
import useSatNoteForm from './useSatNoteForm';

import { FORM_ID } from '../constants';

interface SatNoteFormProps {
  onSuccess?: () => void;
}

const SatNoteForm: FunctionComponent<SatNoteFormProps> = ({ onSuccess }) => {
  const {
    scrollRef,
    form,
    onSubmit,
    page,
    isLoading,
    isSubmitting,
    isIntroduced,
    isSupplyOnly,
    nextButtonProps,
  } = useSatNoteForm(onSuccess);
  return (
    <Form
      id={FORM_ID}
      form={form}
      onSubmit={onSubmit}
      className="max-w-100 mx-auto"
    >
      <FormTheme variant="streamline">
        <div ref={scrollRef} className="absolute top-0" />
        <div className="flex-col w-full mb-6">
          {isLoading && <SatNoteFormLoader isIntroduced={isIntroduced} />}
          {!isLoading && (
            <>
              <ActionRequired />
              <Text
                className="block mb-8 text-2xl text-20-24-em"
                text={
                  isIntroduced ? 'Sign delivery note' : 'Sign satisfaction note'
                }
              />
              {page === 'initial' && (
                <SatNoteFormInitialNotice
                  isIntroduced={isIntroduced}
                  isSupplyOnly={isSupplyOnly}
                />
              )}
              {page === 'terms' && <SatNoteFormTerms />}
              {page === 'questions' && (
                <SatNoteFormQuestions
                  isIntroduced={isIntroduced}
                  isSupplyOnly={isSupplyOnly}
                />
              )}
              <Button.Text {...nextButtonProps} />
              {isIntroduced && (
                <p className="mt-10 text-14-22 text-neutral-600">
                  {HOWDENS_FOOTER}
                </p>
              )}
            </>
          )}
        </div>
        <Loader isLoading={isSubmitting} />
      </FormTheme>
    </Form>
  );
};

export default SatNoteForm;
